const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
  {
    name: 'timestamp',
    value: 'timestamp',
  },
  {
    name: 'Refrence ID',
    value: 'id',
  },
  {
    name: 'Name',
    value: 'collegeName',
  },
  {
    name: 'University',
    value: 'university',
  },
  {
    name: 'Society',
    value: 'society',
  },
  {
    name: 'Total Students',
    value: 'count',
  },
  {
    name: 'Start Year',
    value: 'collegeYear',
  },
  {
    name: 'Website',
    value: 'website',
  },
  {
    name: 'Address',
    value: 'address',
  },
  {
    name: 'State',
    value: 'state',
  },
  {
    name: 'City',
    value: 'city',
  },
  {
    name: 'Degrees',
    value: 'degrees',
  },
  {
    name: 'Streams',
    value: 'streams',
  },
  {
    name: 'Chairman Contact',
    value: 'promoterContact',
  },
  {
    name: 'Principle Contact',
    value: 'principleContact',
  },
  {
    name: 'Head TPO',
    value: 'headTPO',
  },
  {
    name: 'Accreditaions',
    value: 'accreditations',
  },
];

const csvConverter = (JSONData, fileName = 'Registrations') => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;

  let csv = '';
  let row = '';
  let contactLen = 0;
  labels.forEach((fieldName) => {
    if (fieldName.name === 'Chairman Contact') {
      row += `${fieldName.name},`;
      for (let i = 0; i < arrData.length; i += 1) {
        const arrRow = arrData[i].promoterContact.length;

        if (contactLen < arrRow) {
          contactLen = arrRow;
        }
      }
      for (let i = 1; i <= contactLen * 3 - 1; i += 1) {
        row += ',';
      }
    } else if (fieldName.name === 'Principle Contact') {
      row += 'Principle Contact,,,';
    } else if (fieldName.name === 'Head TPO') {
      row += 'Head TPO,,,';
    } else {
      row += `${fieldName.name},`;
    }
  });
  row = row.slice(0, -1);
  csv += `${row}\r\n`;

  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
    // eslint-disable-next-line
    labels.forEach(fieldName => {
      const { value } = fieldName;
      if (value === 'index') {
        row += `${i + 1},`;
      } else if (value === 'timestamp') {
        row += `${new Date(arrRow[value]).toString()},`;
      } else if (value === 'streams') {
        const arr = [];
        for (let j = 0; j < arrRow[value].length; j += 1) {
          arr[j] = arrRow[value][j].stream;
        }
        const streams = arr.join(' | ');
        row += `${streams},`;
      } else if (value === 'promoterContact') {
        arrRow[value].forEach((contact) => {
          row += `${contact.name}, ${contact.email}, ${contact.primaryNum},`;
        });
      } else if (value === 'principleContact') {
        let pointer = 0;
        if (arrRow.promoterContact.length !== contactLen) {
          while (
            pointer <=
            (contactLen - arrRow.promoterContact.length) * 4 - 2
          ) {
            row += ',';
            pointer += 1;
          }
        }
        row += `${arrRow[value].principleName},${
          arrRow[value].principleEmail
        },${arrRow[value].principlePrimaryNum},`;
      } else if (value === 'headTPO') {
        row += `${arrRow[value].headTpoName},${arrRow[value].headTpoEmail},${
          arrRow[value].headTpoPrimaryNum
        },`;
      } else if (value === 'accreditations') {
        arrRow[value].forEach((accred) => {
          row += `${accred.name} - ${accred.year},`;
        });
      } else {
        const arrValue =
          typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      }
    });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }
  // console.log(csv);
  if (csv === '') {
    return;
  }

  const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const link = document.createElement('a');
  link.href = uri;
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default csvConverter;



// WEBPACK FOOTER //
// ./src/utils/CollegeCSV.js